module.exports = __webpack_public_path__ + "img/tsp-volunteer-bg.facb4a1b.jpeg";